import axios from 'axios'
import router from './router/index.js'
import dataMixin from './dataMixin.js'

export default {
    data(){
        return {
            loading : false,
            modelName : null,
            data: null,
            redirectToList: true,
            needsValidation: false,
        };
    },
    mixins: [dataMixin],
    methods: {
        // Id numarası verilen kaydı çekerek 'data' değişkenine atar. Varsa hata bildirimlerini yapar, loading vs. yönetir
        // replaceRouter: Yüklenen kaydın Id'si routerda değiştirilsin mi? EYP formu gibi iç formlar URL'de değişiklik yapmaz.
        // Bu gibi durumlarda false geçilmelidir.
        getData(id, kind = null){
            this.loading = true;
            var url = `/${this.modelName}/get/${id}`;

            if(id == window.emptyObjectId && kind)
                url += '?kind=' + kind;

            return axios
              .get(url)
              .then(x => {
                console.log("POST Result:", x.data);
                this.data = x.data;
                this.loading = false;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.$router.go(-1);
               });
        },
        remove(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/${this.modelName}/delete/${this.data.Id}`, this.data)
              .then(x => {
                console.log("POST Result:", x.data);
                if(x.data.Success) {
                    this.$router.push({ name:this.modelName + 'List' });
                } else {
                    alert(x.data.ErrorMessages);
                    // this.errorMessage = x.data.ErrorMessages;
                }
                this.loading = false;
                return x;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        save(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/${this.modelName}/post/${this.data.Id}`, this.data)
              .then(x => {
                console.log("SAVE Result:", x.data);
                if(this.redirectToList) {
                    this.$router.push({ name:this.modelName + 'List' });
                } else {
                    if(this.data.Id == window.emptyObjectId) {
                        router.replace({ params: { id: this.data.Id } });
                    }

                    this.data = x.data;
                }
                this.loading = false;
                return x;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },

        enableFormValidation()
        {
            this.needsValidation = false;

            var fnValidate = () => {
                setTimeout(() => {
                    if(this.needsValidation)
                        this.validate();
                }, 100);
            };

            const inputs = document.querySelectorAll('form input');
            const tables = document.querySelectorAll('form table');

            inputs.forEach(input => {
                input.addEventListener('blur', () => { this.needsValidation = true; fnValidate(); });
            })

            tables.forEach(input => {
                input.addEventListener('DOMSubtreeModified', () => { this.needsValidation = true; fnValidate(); });
            });
        },

        validate(){
            this.needsValidation = false;

            return axios
              .post(`/${this.modelName}/validate/${this.data.Id}`, this.data)
              .then(x => {
                if(x.data.Success)
                {
                    this.validationData = [];
                }   
                else                 
                    this.validationData = x.data.Data.ModelState;
              })
              .catch(() => {
                this.validationData = [];
                console.log("Validasyon sırasında hata oluştu.");
              });
        },
        goBack(){
            this.$router.push({name:this.modelName + 'List'});
        }
    }
}